import { render, staticRenderFns } from "./SimpleRunActionWidget.vue?vue&type=template&id=708a35ef&scoped=true&"
import script from "./SimpleRunActionWidget.vue?vue&type=script&lang=js&"
export * from "./SimpleRunActionWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708a35ef",
  null
  
)

export default component.exports